// A button that opens an overlay via overlay context
import React from 'react'
import { Button, List, ListItem } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentAdd, PersonAdd } from '@fs/zion-icon'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useR2DispatchContext } from '../../../../../providers/r2Provider/R2Context'

export default function AddNamesToUpdateTreeButton({ noPersonsState }) {
  const { t } = useTranslation()
  const BUTTON_TEXT = t('addNameButton.label', 'Add Name')
  const NO_PERSONS_STATE_BUTTON_TEXT = t('addNamesToUpdateTreeButton.noPersonsStateLabel', 'Add Name')
  const endIcon = <ListItem.Icon Icon={ContentAdd} />
  const startIcon = <ListItem.Icon Icon={PersonAdd} />
  const { openOverlay } = useOverlayContext()
  const r2Dispatch = useR2DispatchContext()

  const handleClick = () => {
    r2Dispatch({ type: 'SET_SELECTED_PERSON_ID', payload: '' })
    openOverlay('addNamesOverlay')
  }

  return (
    <>
      {noPersonsState ? (
        <Button
          fullWidth
          emphasis="high"
          onClick={handleClick}
          data-testid="add-names-to-update-tree-button"
          linkName="add_names_to_update_tree"
        >
          {NO_PERSONS_STATE_BUTTON_TEXT}
        </Button>
      ) : (
        <List>
          <ListItem
            data-testid="add-names-to-update-tree-list-item"
            startElement={startIcon}
            onClick={handleClick}
            primaryText={<b>{BUTTON_TEXT}</b>}
            endElement={endIcon}
            linkName="add_missing_name"
          />
        </List>
      )}
    </>
  )
}
